import { DEL, GET, POST, PUT, setAuthToken } from "../config/ApiConfig";
import { decryptData, encryptData } from "../helpers/EncryptHelper";
import { apiError } from "../helpers/ErrorHelper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dateFormat from "dateformat";
import config from "../config/config";

const module = {
    endPoint: '/users',
    key: 'user_roles'
};

export const create = async (user_token, formData) => {
  setAuthToken(user_token);

  return await POST(`${module.endPoint}/add_user_role`, formData);
};

export const update = async (user_token, id, formData) => {
  setAuthToken(user_token);

  let response = await PUT(`${module.endPoint}/update_user_role/${id}`, formData);
  if (response?.status) {

    let user_data = localStorage.getItem("user_data") ? decryptData(localStorage.getItem("user_data")) : {};
    if (user_data.user_role_id == id) {
      user_data.urole_permission = JSON.parse(formData.get('urole_permission'));
      localStorage.setItem("user_data", encryptData(user_data));
    }
  }

  return response;
};

export const remove = async (user_token, id) => {
  setAuthToken(user_token);

  return await DEL(`${module.endPoint}/delete_user_role/${id}`);
};

export const saveToStorage = (data, pagination) => {
  if (! config.isCache) {
    return;
  }

  let currentTime = dateFormat("", "dd mmm yyyy HH:MM:ss");

  const dataToStore = {
    [module.key]: data,
    pagination: pagination,
    time: currentTime,
  };
  localStorage.setItem(module.key, encryptData(dataToStore));
};

export const getData = async (param = {}) => {
  let user_token = param.user_token;

  if (! user_token) {
    return [];
  }

  let page = param.page ? param.page : 1;
  let limit = param.limit ? param.limit : 10;

  if (config.isCache && page == 1 && limit == 10 && localStorage.getItem(module.key)) {
    return decryptData(localStorage.getItem(module.key));
  }

  try {
    setAuthToken(user_token);

    const url = `${module.endPoint}/user_role_list?page=${page}&limit=${limit}`;
    const response = await GET(url);
    if (! response.status) { 
        toast.error(response.message);
    }

    if (page == 1 && limit == 10) {
        saveToStorage(response.data[module.key], response.data.pagination);
    }

    return response.data;

  } catch (error) {
      apiError(error);

      console.log(error);
  }
};
